import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/hotelschool-the-hague/hotelschool-frontend/layouts/default.vue").then(m => m.default || m))
}